import React, { useState, useEffect } from "react"
import dynamic from "next/dynamic"
import { useTranslation } from "next-i18next"
import { getConfig } from "@/constants/config"
import QuantitySelector from "@/components/cart/QuantitySelector"
import Modal from "@/components/core/Modal/Modal"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import useWindowResize from "@/hooks/useWindowResize"
import DisplayDiscountPrice from "@/components/Shared/DisplayDiscountPrice"
import { getPresetUrl } from "@/utils"
import Style from "@/components/Shared/UpsellInstallServices/RequiredProductItem/index.module.scss"
import { addAnalyticsForIncludeforRequiredItem } from "@/components/Shared/UpsellInstallServices/analytics"
import {
  quickViewCloseAnalytics,
  quickViewOpenAnalytics,
} from "@/components/Shared/QuickView/analytics.js"
import { getTranslations } from "@/components/Shared/UpsellInstallServices/localization"
import { preventPopupScroll } from "@/components/Shared/QuickView/utlis"

const QuickView = dynamic(() => import("@/components/Shared/QuickView"))

const RequiredProductItem = ({
  persona = "GST",
  requiredProductItem = {},
  currencySign = "$",
  parsedConfigs = {},
  rowCols = 0,
  baseUrl = "",
  recommendationSource,
  parentSku = "",
  includedItems = [],
  upSellDataIndex = -1,
  quantityChangeHanlder = () => {},
  updateRequiredItems = () => {},
  includeTitle = "",
  recommendationTitle = "",
  outOfStockTitle = "",
  showQtyInput = true,
  dynamicClass = "",
  index = 1,
  installServiceDataAvailable = false,
  cartProductData = {},
  quickViewAuthData = {},
  productData = {},
  openQuickViewModal = () => {},
  isPdp = "",
  quickViewButtonLabel = "",
}) => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t, outOfStockTitle)
  const { outOfStockLabel = "", backOrderMssg = () => {} } = staticText

  useEffect(() => {
    checkSkuKPrepend()
  }, [])

  const [skuPrependName, setSkuPrependName] = useState("")
  const [showQuickViewModal, setShowQuickViewModal] = useState(false)
  const [productInfo, setProductInfo] = useState({})

  const handleProductInfo = data => {
    setProductInfo(data)
  }

  const handleButtonClosed = () => {
    quickViewCloseAnalytics({
      productInfo,
      recommendationSource,
    })
  }

  const [width] = useWindowResize()
  const {
    sku_s: skuId = "",
    ProductBrandName_s: productBrandName = "",
    productName_s: productName = "",
    [`priceList.${persona}.price_d`]: productPrice = 0,
    [`priceList.${persona}.discountedPrice_d`]: discountedPrice = 0,
    ["productImages.labelWithUrl_ss"]: productImage = [],
    availableQuantity = 0,
    RegionIsBackorderable_b: isBackorderable = false,
    RegionLeadTime_i: leadTime = 0,
  } = requiredProductItem

  let imgId = ""
  if (productImage.length) {
    const index = productImage
      .map(item => (item.split("|")?.length ? item.split("|")[0] : ""))
      .indexOf(skuId)
    const assetId = productImage[index]?.split("|")?.length
      ? productImage[index].split("|")[1]
      : ""
    imgId = assetId
  }

  const requiredProdImgUrl = getPresetUrl(
    width,
    rowCols,
    baseUrl,
    imgId,
    parsedConfigs
  )
  const accessibleSkuLabel =
    skuPrependName.toLowerCase() === skuId.substring(0, 2).toLowerCase()
      ? skuId
      : `${skuPrependName ? skuPrependName : ""}${skuId}`
  const productLabel = productBrandName || productName
  const includeCheckboxAriaLabel = `${includeTitle} ${productLabel} ${accessibleSkuLabel}`
  const isChecked =
    includedItems[parentSku]?.includedItems[skuId]?.check ?? false
  const checkChangeHandler = (e, requiredProductItem) => {
    const { target: { checked = false } = {} } = e
    updateRequiredItems(checked, parentSku, skuId, upSellDataIndex)
    const qty = includedItems[parentSku]?.includedItems[skuId]?.quantity ?? 1
    const installServiceDataAvailableIndex = installServiceDataAvailable
      ? index + 1
      : index
    addAnalyticsForIncludeforRequiredItem({
      checked,
      included: includeTitle,
      recommendationTitle,
      installServiceData: requiredProductItem,
      index: upSellDataIndex,
      childindex: installServiceDataAvailableIndex,
      persona,
      isParent: "",
      qty,
      recommendationSource,
    })
  }

  const checkSkuKPrepend = async () => {
    const { apiEndpoints: { skuPrepend = "" } = {} } = (await getConfig()) ?? {}
    setSkuPrependName(skuPrepend)
  }

  const openPdpQuickViewModal = productData => {
    quickViewOpenAnalytics({
      productData,
      productImageUrl: requiredProdImgUrl,
      recommendationSource: recommendationSource,
    })
    setShowQuickViewModal(true)
  }
  const closeQuickViewModal = () => {
    setShowQuickViewModal(false)
    preventPopupScroll(true)
  }
  const openQuickViewModalCartPdp = productData => {
    isPdp ? openPdpQuickViewModal(productData) : openQuickViewModal(productData)
  }

  useEffect(() => {
    if (showQuickViewModal) {
      preventPopupScroll()
    }
  }, [showQuickViewModal])

  return (
    <div className={Style.requireditem}>
      <div className={`required-item-for-install-service${dynamicClass}`}>
        <div className="required-item-for-install-service__img">
          <img src={requiredProdImgUrl} alt="" />
        </div>
        <div className="required-item-for-install-service__title">
          {productBrandName || productName}
        </div>
        <div className="required-item-for-install-service__sku">
          {accessibleSkuLabel}
        </div>
        <div className="required-item-for-install-service__price-quantity">
          <div className="required-item-for-install-service__price">
            <DisplayDiscountPrice
              discountedPrice={discountedPrice}
              price={productPrice}
              currencySign={currencySign}
            />
          </div>

          {showQtyInput && availableQuantity ? (
            <div className="required-item-for-install-service__quantity">
              <QuantitySelector
                size="small"
                source="cart-landing"
                value={1}
                onChange={(qty, action) =>
                  quantityChangeHanlder(
                    qty,
                    parentSku,
                    skuId,
                    upSellDataIndex,
                    action,
                    requiredProductItem,
                    index,
                    installServiceDataAvailable,
                    cartProductData
                  )
                }
              />
            </div>
          ) : null}
        </div>
        {!availableQuantity && !isBackorderable ? (
          <div className="not-in-stock">{outOfStockLabel}</div>
        ) : (
          <>
            <div className="required-item-for-install-service__include cart-quickview-section">
              <div className="include-div">
                <div className="checkbox">
                  <Checkbox
                    checkBoxAria={includeCheckboxAriaLabel}
                    checked={isChecked}
                    onChange={e => checkChangeHandler(e, requiredProductItem)}
                  />
                </div>
                {includeTitle}
              </div>

              {quickViewButtonLabel ? (
                <div className="quick-view-title">
                  <p
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      openQuickViewModalCartPdp(productData)
                    }}
                  >
                    {quickViewButtonLabel}
                  </p>
                </div>
              ) : null}
            </div>
            {!availableQuantity && isBackorderable ? (
              <p className="backorder-label">{backOrderMssg(leadTime)}</p>
            ) : null}
          </>
        )}
        {/* <div className="number-in-stock">
        <img src={TooltipIcon.src} alt="" />
        <div className="number-in-stock__msg">9 item(s) available to ship.</div>
      </div> */}
      </div>
      {isPdp ? (
        <Modal
          showModal={showQuickViewModal}
          onModalClose={closeQuickViewModal}
          className="quickview-modal"
          isCloseButtonClicked={handleButtonClosed}
        >
          <QuickView
            productData={productData}
            authorData={quickViewAuthData}
            closeModal={closeQuickViewModal}
            handleProductInfo={handleProductInfo}
            recommendationSource={recommendationSource}
          />
        </Modal>
      ) : null}
    </div>
  )
}

export default RequiredProductItem
